export const createWorker = (
  worker: CallableFunction,
  workerScriptURL: string
) => {
  const code = worker.toString()

  const blob = new Blob([`importScripts('${workerScriptURL}');(${code})()`], {
    type: 'text/javascript',
  })

  return new Worker(URL.createObjectURL(blob))
}
